import React from "react";
import { slide as Menu } from "react-burger-menu";

export default props => {
  return (
    // Pass on our props
    <Menu {...props}>
      <a className="menu-item" href="#main">
        Главная
      </a>

      <a className="menu-item" href="#functionality">
        Возможности
      </a>

      <a className="menu-item" href="#about">
        О нас
      </a>

      <a className="menu-item" href="#purchase">
        Подключиться
      </a>
    </Menu>
  );
};
